import { commonConstants } from '../_constants';
import { initialState } from '../_helpers';

export function entities(state=initialState.entities, action) {
    switch (action.type) {
        case commonConstants.GET_ENTITIES:
            return action.entities;
        default:
            return state
      }
}



// WEBPACK FOOTER //
// ./src/_reducers/entityTypes.reducer.js